import { unref } from "@nuxtjs/composition-api";
import { useSettingsStore } from "~/stores/settings";

export default function useCapital() {
  const settingsStore = useSettingsStore();

  const isCapital = (value) => {
    return Number(unref(value)?.id) === settingsStore.capitalCityId;
  };

  return { isCapital };
}
